export const initialPlayerState = {
  answers: [],
  questionId: "",
  answerLocked: false,
  question: "",
};
